/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'spark': {
    width: 16,
    height: 16,
    viewBox: '0 0 48 48',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M24 1c1.15 0 2.1.94 2.1 2.1v8.35a2.1 2.1 0 1 1-4.2 0V3.1c0-1.16.96-2.1 2.1-2.1zm0 33.45c1.15 0 2.1.94 2.1 2.1v8.36a2.1 2.1 0 1 1-4.2 0v-8.36c0-1.16.95-2.1 2.1-2.1zM7.74 7.74a2.1 2.1 0 0 1 2.96 0l5.91 5.92a2.1 2.1 0 1 1-2.95 2.95L7.74 10.7a2.1 2.1 0 0 1 0-2.96zm23.65 23.65a2.1 2.1 0 0 1 2.95 0l5.92 5.91a2.1 2.1 0 1 1-2.96 2.96l-5.91-5.92a2.1 2.1 0 0 1 0-2.95zM1 24c0-1.15.94-2.1 2.1-2.1h8.35a2.1 2.1 0 1 1 0 4.2H3.1A2.1 2.1 0 0 1 1 24zm33.45 0c0-1.15.94-2.1 2.1-2.1h8.36a2.1 2.1 0 1 1 0 4.2h-8.36a2.1 2.1 0 0 1-2.1-2.1zm-17.84 7.39a2.1 2.1 0 0 1 0 2.95l-5.91 5.92a2.1 2.1 0 1 1-2.96-2.96l5.92-5.91a2.1 2.1 0 0 1 2.95 0zM40.26 7.74a2.1 2.1 0 0 1 0 2.96l-5.92 5.91a2.1 2.1 0 1 1-2.95-2.95l5.91-5.92a2.1 2.1 0 0 1 2.96 0z"/>'
  }
})
